"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param item Item to check
 * @param item.name Name of the item to check
 * @returns If its or not considered hidden
 */
function isHiddenItem(item) {
    return !!item.name.match(/^\./);
}
exports.default = isHiddenItem;
